/** Namespaced SVG element builder (CSP-clean: DOM construction, no innerHTML). */
const NS = 'http://www.w3.org/2000/svg';

export function svgEl<K extends keyof SVGElementTagNameMap>(
  tag: K,
  attrs: Readonly<Record<string, string | number>> = {},
  text?: string,
): SVGElementTagNameMap[K] {
  const node = document.createElementNS(NS, tag);
  for (const [k, v] of Object.entries(attrs)) node.setAttribute(k, String(v));
  if (text !== undefined) node.textContent = text;
  return node;
}

/** Create a viewBox-based <svg> sized to 100% (fills its VisualFrame). */
export function svgRoot(viewBoxW: number, viewBoxH: number, label: string): SVGSVGElement {
  const root = svgEl('svg', {
    viewBox: `0 0 ${viewBoxW} ${viewBoxH}`,
    preserveAspectRatio: 'xMidYMid meet',
    width: '100%',
    height: '100%',
    role: 'img',
    'aria-label': label,
  });
  return root;
}
